import React from "react";
import Layout from "@/components/Layout";
import { OPERATOR, operatorBankLine } from "@/lib/operator";

const SECTIONS = [
  {
    h: "1. Provozovatel",
    p: [
      `Provozovatelem inzertního portálu STAVBOŠ (${OPERATOR.site}) je výhradně společnost ${OPERATOR.company}, IČO ${OPERATOR.icPretty}, se sídlem ${OPERATOR.address}, Česká republika, zapsaná u ${OPERATOR.registry}. Společnost není plátcem DPH.`,
      `${operatorBankLine()}. Platby za TOP (49 Kč) přijímá pouze ${OPERATOR.company}.`,
      `Kontakt: ${OPERATOR.email}`,
    ],
  },
  {
    h: "2. Charakter služby",
    p: [
      "STAVBOŠ je inzertní portál zaměřený výhradně na stavební materiál, nářadí, stroje a techniku.",
      "Vkládání inzerátů je zdarma. Provozovatel poskytuje doplňkovou službu TOP inzerát za poplatek 49 Kč.",
    ],
  },
  {
    h: "3. Registrace a obsah inzerátů",
    p: [
      "Před vložením inzerátu je uživatel povinen registrovat se a ověřit svůj email.",
      "Uživatel odpovídá za pravdivost a úplnost informací uvedených v inzerátu.",
      "Zakázáno je vkládat inzeráty, které: porušují právní řád ČR, propagují nelegální zboží, obsahují urážlivý nebo klamavý obsah, nebo nejsou v souladu se zaměřením portálu (jen stavební materiál, nářadí, technika).",
    ],
  },
  {
    h: "4. TOPování inzerátu",
    p: [
      "Uživatel může vlastní inzerát zviditelnit prostřednictvím služby TOP za 49 Kč na 14 dní.",
      "Platba probíhá přes platební bránu Stripe. Po úspěšné platbě je inzerát ihned posunut na přední pozice.",
      "Konkurenční inzeráty mohou být přebíjeny dalším topnutím.",
    ],
  },
  {
    h: "5. Odpovědnost provozovatele",
    p: [
      "Provozovatel není prodejcem inzerovaného zboží a nenese odpovědnost za obsah inzerátů ani za jednání mezi uživateli.",
      "Provozovatel si vyhrazuje právo odstranit inzerát, který porušuje tyto podmínky, bez nároku na vrácení platby za TOP.",
    ],
  },
  {
    h: "6. Reklamace platby za TOP",
    p: [
      "Reklamaci platby za službu TOP lze uplatnit e-mailem na stavbos@post.cz do 14 dnů od provedení platby, pokud služba prokazatelně nebyla poskytnuta.",
    ],
  },
  {
    h: "7. Závěrečná ustanovení",
    p: [
      "Tyto obchodní podmínky se řídí právním řádem České republiky.",
      "Provozovatel je oprávněn podmínky kdykoli změnit; změna nabývá účinnosti dnem zveřejnění.",
    ],
  },
];

export default function TermsPage() {
  return (
    <Layout>
      <article className="max-w-3xl stb-card p-6" data-testid="terms-page">
        <h1 className="stb-h text-3xl text-white">Obchodní podmínky</h1>
        <p className="stb-label mt-1">Účinné od 19. 9. 2026</p>
        <hr className="stb-divider" />
        {SECTIONS.map((s, i) => (
          <section key={i} className="mb-5">
            <h2 className="stb-h text-xl text-[#FF6B00]">{s.h}</h2>
            {s.p.map((t, j) => (
              <p key={j} className="text-[#E5E5E5] mt-2 leading-relaxed">{t}</p>
            ))}
          </section>
        ))}
      </article>
    </Layout>
  );
}
